import {React, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft, Construction, AlertTriangle } from 'lucide-react';

const NotFound = () => {

      useEffect(() => {
      document.title = "Marvel Sato | 404";
    }, []);
    
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6 py-24">
      <div className="max-w-3xl w-full text-center">
        
        {/* Animated Icon Section */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="relative inline-block mb-8"
        >
          <div className="absolute inset-0 bg-orange-200 blur-3xl rounded-full opacity-30 animate-pulse"></div>
          <div className="relative bg-white p-8 rounded-[2.5rem] shadow-xl border border-slate-100">
            <Construction size={80} className="text-slate-900 mx-auto" strokeWidth={1.5} />
            <motion.div 
              animate={{ rotate: [0, -10, 10, 0] }}
              transition={{ repeat: Infinity, duration: 2 }}
              className="absolute -top-2 -right-2 bg-orange-500 text-white p-2 rounded-full shadow-lg"
            >
              <AlertTriangle size={20} />
            </motion.div>
          </div>
        </motion.div>

        {/* Text Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <h1 className="text-8xl md:text-9xl font-black text-slate-900 leading-none italic uppercase tracking-tighter">
            404
          </h1>
          <h2 className="text-2xl md:text-3xl font-black text-slate-800 uppercase italic mt-4">
            Off-Road <span className="text-orange-500">Alert!</span>
          </h2>
          <p className="text-slate-500 max-w-md mx-auto mt-4 text-sm md:text-base font-medium leading-relaxed">
            The page you are looking for has been moved, removed, or is currently under heavy maintenance. Let's get you back on track.
          </p>
        </motion.div>

        {/* Action Buttons */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12"
        >
          <Link to="/" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-slate-900 text-white px-8 py-4 rounded-xl font-black uppercase text-xs tracking-widest hover:bg-orange-500 transition-all shadow-lg shadow-slate-200">
            <Home size={16} /> Return Home
          </Link>
          
          <button 
            onClick={() => window.history.back()}
            className="w-full sm:w-auto flex items-center justify-center gap-2 border-2 border-slate-900 text-slate-900 px-8 py-4 rounded-xl font-black uppercase text-xs tracking-widest hover:bg-slate-100 transition-all"
          >
            <ArrowLeft size={16} /> Go Back
          </button>
        </motion.div>

        {/* Decorative Industrial Pattern */}
        <div className="mt-20 flex justify-center gap-2 opacity-20">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="w-12 h-2 bg-orange-500 skew-x-12"></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotFound;